import * as React from 'react'
import { useFlowium } from '../client/FlowiumContext'
import Modal from './Modal'
import Input from './Input'
import Button from './Button'

interface CreateWorkspaceModalProps {
    isOpen: boolean
    onClose: () => void
}

const CreateWorkspaceModal: React.FC<CreateWorkspaceModalProps> = ({ isOpen, onClose }) => {
    const [name, setName] = React.useState('')
    const [isLoading, setIsLoading] = React.useState(false)
    const [error, setError] = React.useState<string | null>(null)
    const { client, fetchUserData } = useFlowium()

    React.useEffect(() => {
        if (isOpen) { setName(''); setError(null) }
    }, [isOpen])

    const handleSubmit = async () => {
        const trimmedName = name.trim()
        if (!trimmedName) return
        setIsLoading(true)
        setError(null)
        try {
            const workspaceId = await client.createWorkspace(trimmedName)
            await client.setWorkspace(undefined, workspaceId)
            await fetchUserData()
            onClose()
        } catch (err) {
            setError('Failed to create workspace')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Create New Workspace"
            description="Enter a name for your new workspace."
            size="sm"
            footer={
                <div className="flex justify-end gap-2">
                    <Button variant="ghost" onClick={onClose} disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} disabled={isLoading || !name.trim()}>
                        {isLoading ? 'Creating...' : 'Create Workspace'}
                    </Button>
                </div>
            }
        >
            {error && <p className="text-error text-sm mb-2">{error}</p>}
            <Input
                label="Workspace name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Santa's Workshop"
                disabled={isLoading}
            />
        </Modal>
    )
}

export default CreateWorkspaceModal
